import React, { useMemo, useRef, useState, useEffect } from 'react'
import { Box } from '@mui/material'
import { EmtTypography, EmtModal, EmtButton } from 'emt-components-v2'

import useIsResponsive from '@/hooks/useIsResponsive'
import { useSignUpCallRequestStore } from '@/store/signUpCallRequestStore'

import AdditionalInformationsForm, { AdditionalInformationsValues } from './AdditionalInformationsForm'

import type { AdditionalInformationsHandle } from '@/components/pages/pet-sitter/reservations/NewRequest/AdditionalInformations'

interface EditAdditionalInformationsModalProps {
  open: boolean
  setOpen: (open: boolean) => void
}

const EditAdditionalInformationsModal: React.FC<EditAdditionalInformationsModalProps> = ({ open, setOpen }) => {
  const [isMobile] = useIsResponsive()

  const pets = useSignUpCallRequestStore((s) => s.animals)
  const service = useSignUpCallRequestStore((s) => s.service)

  const message = useSignUpCallRequestStore((s) => s.message)
  const setMessage = useSignUpCallRequestStore((s) => s.setMessage)

  const additionalInformations = useSignUpCallRequestStore((s) => s.additionalInformations)
  const setAdditionalInformations = useSignUpCallRequestStore((s) => s.setAdditionalInformations)

  const [localAdditionalInformations, setLocalAdditionalInformations] =
    useState<AdditionalInformationsValues>(additionalInformations)

  const [localDescription, setLocalDescription] = useState(message || '')

  const additionalInfosRef = useRef<AdditionalInformationsHandle | null>(null)
  const hasSelectedDog = useMemo(() => pets.some((pet: any) => pet.selectedRadio === 'dog'), [pets])

  const handleSave = () => {
    const ok = additionalInfosRef.current?.validate?.()
    if (ok === false) return

    setAdditionalInformations(localAdditionalInformations)
    setMessage(localDescription)
    setOpen(false)
  }

  useEffect(() => {
    setLocalAdditionalInformations(additionalInformations)
  }, [additionalInformations])

  useEffect(() => {
    setLocalDescription(message || '')
  }, [message])

  return (
    <EmtModal
      open={open}
      onClose={(event: React.MouseEvent) => {
        event.stopPropagation()
        setOpen(false)
      }}
      sx={{
        '& .inner-box': { width: '800px', maxWidth: '90vw' },
        '& .children-box': { padding: isMobile ? '26px' : '66px' },
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
        onClick={(e: React.MouseEvent) => e.stopPropagation()}
      >
        <EmtTypography variant="h4" fontWeight={800}>
          Modifier les caractéristiques des animaux :
        </EmtTypography>

        <AdditionalInformationsForm
          isMobile={isMobile}
          //@ts-expect-error
          pets={pets}
          service={service?.selectedService || ''}
          hasSelectedDog={hasSelectedDog}
          values={localAdditionalInformations}
          setValues={setLocalAdditionalInformations}
          description={localDescription}
          setDescription={setLocalDescription}
          additionalInfosRef={additionalInfosRef}
          sx={{ padding: 0 }}
        />

        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            gap: '10px',
            justifyContent: 'center',
          }}
        >
          <EmtButton fullWidth variant="outlined" size="medium" color="purple" onClick={() => setOpen(false)}>
            Annuler
          </EmtButton>
          <EmtButton fullWidth variant="contained" size="medium" color="purple" onClick={handleSave}>
            Continuer
          </EmtButton>
        </Box>
      </Box>
    </EmtModal>
  )
}

export default EditAdditionalInformationsModal
